import _ from "lodash"
import {UseRootProperty} from "@/mixins/AuthorizationHelpers/UseRootProperty";

export class FeatureLevelHelper extends UseRootProperty {
    constructor(mixin) {
        super(mixin, 'features', FeatureLevelHelper.ROOT_KEY)
    }

    hasFeature(feature, company = null) {
        if (this._isNotReady()) {
            return false
        }

        company = this.mixin.currentCompanyIfNull(company)
        let features = this.getFeatures(company)

        // Using the array of permissions to check if the permission exists for this company.
        return features.indexOf(feature) !== -1
    }

    getFeatures(company = null) {
        if (this._isNotReady()) {
            return false
        }

        company = this.mixin.currentCompanyIfNull(company)
        this.loadCompany(company)

        // Verify the company has an array and return the company's array
        this._prepareCompany(company)
        let featureData = this._getRootProperty(company)
        return featureData['features']
    }

    getFeatureLevelName(company = null) {
        if (this._isNotReady()) {
            return false
        }

        company = this.mixin.currentCompanyIfNull(company)
        this.loadCompany(company)

        // Verify the company has an array and return the company's array
        this._prepareCompany(company)
        let featureData = this._getRootProperty(company)
        return featureData['name']
    }

    featuresLoaded(company = null) {
        company = this.mixin.currentCompanyIfNull(company)
        return this._getCompanyStatus(company)
    }
}

FeatureLevelHelper.ROOT_KEY = 'features'
